
import { FOOTER_MSG_STORE } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: FOOTER_MSG_STORE,
  computed: {
    stateMsgForStore () {
      return this.$store.getters.stateMsgForStore.length > 1 ? this.$store.getters.stateMsgForStore : ['inPreparation', 'weCantTakeOrdersAtThisTime']
    }
  }
})
